import { Component, OnInit } from '@angular/core';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
@Component({
  selector: 'redirect-silent-renew',
  templateUrl: './redirect-silent-renew.component.html',
  styleUrls: ['./redirect-silent-renew.component.scss']
})
export class RedirectSilentRenewComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {
    console.log('---------> redirect-silent-renew ngOnInit ----------')
  }
}
